// import { TextResult } from "capacitor-plugin-dynamsoft-barcode-reader";
import { reactive } from "vue";
import favoriteImg from "@/assets/images/star-rounded.svg";
import shelfImg from "@/assets/images/no-box.svg";
import routineImg from "@/assets/images/routine.svg";
import squadImg from "@/assets/images/user-group.svg";

export const countries = [
  { country: "United States", code: "1", iso: "US" },
  { country: "Canada", code: "1", iso: "CA" },
  { country: "Bahamas", code: "1-242", iso: "BS" },
  { country: "Costa Rica", code: "506", iso: "CR" },
  { country: "Jamaica", code: "1-876", iso: "JM" },
  { country: "Mexico", code: "52", iso: "MX" },
];

export const states = reactive({
  QRCodeOnly: false,
  continuousScan: false,
  barcodeResults: [] as any[],
});

export const NO_FAVORITE_DATA = {
  title: "favorite",
  image: favoriteImg,
  description: "No Favorite Items Yet",
}

export const NO_SHELF_DATA = {
  title: "product",
  image: shelfImg,
  description: "No Products Yet",
}

export const NO_ROUTINE_DATA = {
  title: "routine",
  image: routineImg,
  description: "No Routines Yet",
}

export const NO_SQUAD_DATA = {
  title: "squad",
  image: squadImg,
  description: "No Members Yet",
}

export const REVIEW_TYPE = {
  BRAND: "brand",
  PRODUCT: "product",
  EVENT: "event",
}